import { Box } from '@stockx/ui';
import React from 'react';

export const HeaderContainer = ({ children }) => (
  <Box
    id="site-header"
    data-component="SiteHeader"
    data-testid="SiteHeader"
    position="sticky"
    top="0"
    zIndex="1030"
  >
    {children}
  </Box>
);
